import request from "@/shared/api/request";

export interface PrivacyUnlockReply {
  token: string;
  expires_at: string;
}

export function savePrivacyPassword(masterPassword: string, privacyPassword: string) {
  return request.put<Record<string, never>>("/api/v1/users/privacy/password", {
    master_password: masterPassword,
    new_privacy_password: privacyPassword,
  });
}

export function unlockPrivacy(privacyPassword: string) {
  return request.post<PrivacyUnlockReply>("/api/v1/users/privacy/unlock", {
    privacy_password: privacyPassword,
  });
}
